import {setGetAlfakitBalanceAction} from '../action';
import { getAlfakitBalance } from '../api/getAlfakitBalance';

export const setGetAlfakitBalance = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getAlfakitBalance(params);
            if (data.status === 'success') {
                dispatch(setGetAlfakitBalanceAction(data.data));           
            }
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}